import lodash from "lodash"
import axios from "axios"
import axiosOverlay from '../../js/axiosOverlay'

const etats = [
    {statut: 'notClosed', lettres: ['A', 'N', 'O']},
    {statut: 'closed', lettres: ['R', 'C']}
];

const maxSizeURL = 500;
var source = axios.CancelToken.source();

// Getters helpers
const getFilter = function (getters) {
    let mesCat = getters['categories/iCantRead'];
    let idCats = mesCat.map(function (value) {
        return value['id'];
    });
    
    let mesType = getters['types/iCantRead'].filter(e => !idCats.includes(e.categorie));
    let idTypes = mesType.map(function (value) {
        return value['id'];
    });

    let mesNat = getters['natures/iCantRead'].filter(e =>
        !idTypes.includes(e.type) &&
        !idCats.includes(getters['types/getTypeById'](e.type)?.categorie));
    let idNats = mesNat.map(function (value) {
        return value['id'];
    });
    
    let mesMot = getters['motifs/iCantRead'].filter(e =>
        !idNats.includes(e.nature) &&
        getters['natures/getNatureById'](e.nature) &&
        !idCats.includes(getters['types/getTypeById'](getters['natures/getNatureById'](e.nature)?.type)?.categorie) &&
        !idTypes.includes((getters['natures/getNatureById'](e.nature)).type)
    );
    let idMotifs = JSON.stringify(mesMot.map(function (value) {
        return value['id'];
    }));

    idCats = JSON.stringify(idCats);
    idTypes = JSON.stringify(idTypes);
    idNats = JSON.stringify(idNats);

    let res = {};
    res.cats = mesCat.length > 0 ? idCats : null;
    res.types = mesType.length > 0 ? idTypes : null;
    res.nats = mesNat.length > 0 ? idNats : null;
    res.motifs = mesMot.length > 0 ? idMotifs : null;

    return res;
}

const getFilterUrl = function (getters) {
    let filter = getFilter(getters);
    let url = "";
    if (filter.cats != null)
        url += "&categorie=" + filter.cats
    if (filter.nats != null)
        url += "&nature=" + filter.nats
    if (filter.motifs != null)
        url += "&motif=" + filter.motifs
    if (filter.types != null)
        url += "&type=" + filter.types;

    return url;
}

const increaseFlag = function (etat, commit) {
    if (etat.statut == 'notClosed')
        commit('INCREASE_NOT_CLOSED_LOADING')
    else
        commit('INCREASE_CLOSED_LOADING');
}

const decreaseFlag = function (etat, commit) {
    if (etat.statut == 'notClosed')
        commit('DECREASE_NOT_CLOSED_LOADING')
    else
        commit('DECREASE_CLOSED_LOADING');
}

const state = {
    sollicitations: null,
    sollicitationsToSend: null,
    selectedSollicitation: null,
    sollicitationsCreated: null,
    sollicitationsAffected: null,
    sollicitationsMonPatrimoine: null,
    allSollicitations: null,
    currentlyShown: null,
    notClosedLoading: 0,
    closedLoading: 0
};

const getters = {
    notClosedIsLoading: state => state.notClosedLoading > 0,
    closedIsLoading: state => state.closedLoading > 0,
    getSollicitationsOrderByDate: state => {
        if (!state.sollicitations) return []
        return lodash.orderBy(JSON.parse(state.sollicitations), ['debut'], ['desc'])
    },
    getSollicitationById: state => (sollicitationID) => {
        if (!state.sollicitations) return []
        return JSON.parse(state.sollicitations).filter(sollicitation => sollicitation.id === sollicitationID)
    },
    getSollicitationsCurrentlyShown: state => state.currentlyShown,
    selectedSollicitation: state => state.selectedSollicitation,
    sollicitationsCreated: state => state.sollicitationsCreated,
    sollicitationsAffected: state => state.sollicitationsAffected,
    allSollicitations: state => state.allSollicitations,
    getFullAdresse: (state, getters, rootState, rootGetters) => (sollicitation) => {
        if (sollicitation.entree != undefined && sollicitation.entree != "" && sollicitation.entree != null) {
            if (state.sollicitations !== null) {
                try {
                    let entree = rootGetters['entrees/getEntreeByID'](sollicitation.entree)[0]
                    let res = 'Entree ' + entree.lesc
                    res += (sollicitation.etage != null && sollicitation.etage != undefined) ? ' étage ' + sollicitation.etage : ''
                    res += ', ' + entree.numeroRue + ' ' + entree.rue + ' (' + entree.commune + ')'
                    return res
                } catch (e) {
                    return '(Erreur) Infos adresse non trouvée '
                }
            } else {
                return '-'
            }
        }

        if (sollicitation.programme != undefined && sollicitation.programme != null && sollicitation.programme != "") {
            let programme = rootGetters['programmes/getProgrammeById'](sollicitation.programme)
            return 'Programme ' + programme.nom
        }

        return '(Erreur) Infos adresse non trouvée'
    }
};

const mutations = {
    SET_SOLLICITATIONS(state, sollicitations) {
        state.sollicitations = sollicitations;
    },
    SET_SOLLICITATIONS_CREATED(state, sollicitations) {
        state.sollicitationsCreated = sollicitations;
    },
    SET_SOLLICITATIONS_AFFECTED(state, sollicitations) {
        state.sollicitationsAffected = sollicitations;
    },
    SET_SOLLICITATIONS_MON_PATRIMOINE(state, sollicitations) {
        state.sollicitationsMonPatrimoine = sollicitations;
    },
    SET_ALL_SOLLICITATIONS(state, sollicitations) {
        state.allSollicitations = sollicitations;
    },
    SET_CURRENTLY_SHOWN(state, currentlyShown) {
        state.currentlyShown = currentlyShown;
    },
    SET_SELECTED_SOLLICITATION(state, sollicitation) {
        state.selectedSollicitation = sollicitation;
    },
    INCREASE_NOT_CLOSED_LOADING(state) {
        state.notClosedLoading++;
    },
    DECREASE_NOT_CLOSED_LOADING(state) {
        state.notClosedLoading--;
    },
    INCREASE_CLOSED_LOADING(state) {
        state.closedLoading++;
    },
    DECREASE_CLOSED_LOADING(state) {
        state.closedLoading--;
    },
    CLEAR_SOLLICITATIONS(state) {
        state.sollicitationsCreated = null;
        state.sollicitationsAffected = null;
        state.allSollicitations = null;
        state.sollicitationsMonPatrimoine = null;
        state.notClosedLoading = 0;
        state.closedLoading = 0;
    }
};

const actions = {
    switchCreated({ commit, state }) {
        commit('SET_SOLLICITATIONS', state.sollicitationsCreated);
        commit('SET_CURRENTLY_SHOWN', 'created');
    },
    
    switchAffected({ commit, state }) {
        commit('SET_SOLLICITATIONS', state.sollicitationsAffected);
        commit('SET_CURRENTLY_SHOWN', 'affected');
    },
    
    switchPatrimoine({ commit, state }) {
        commit('SET_SOLLICITATIONS', state.sollicitationsMonPatrimoine);
        commit('SET_CURRENTLY_SHOWN', 'patrimoine');
    },
    
    switchAll({ commit, state }) {
        commit('SET_SOLLICITATIONS', state.allSollicitations);
        commit('SET_CURRENTLY_SHOWN', 'all');
    },

    async loadSollicitationsPatrimoineFromAPI({ commit, getters, rootGetters, dispatch }, debutgt = 1577836800) {
        console.log('loadSollicitationsPatrimoineFromAPI called with debutgt:', debutgt);
        console.log('getSollicitationsCurrentlyShown:', getters.getSollicitationsCurrentlyShown);

        await dispatch('switchPatrimoine');
            let nbEntrees = rootGetters['partenaires/entrees'].length;
            let nbProgs = rootGetters['partenaires/programmes'].length;
            commit('SET_SOLLICITATIONS_MON_PATRIMOINE', JSON.stringify([]));

            let url = "";
            let baseUrl = process.env.VUE_APP_API_URL + "/sollicitations?debut[gt]=" + debutgt;
            baseUrl += getFilterUrl(rootGetters);

            let maxCount;

            etats.forEach(etat => {
                if (nbEntrees > 0) {
                    let entrees = rootGetters['partenaires/entrees'];
                    maxCount = (maxSizeURL - baseUrl.length) / 19;
                    if (maxCount >= 1) {
                        do {
                            increaseFlag(etat, commit);
                            url = baseUrl + "&entree=" + JSON.stringify(entrees.slice(0, maxCount));
                            url += "&etat=" + JSON.stringify(etat.lettres);

                            let config = {
                                method: 'get',
                                url: url,
                                headers: {},
                                cancelToken: source.token
                            };

                            axiosOverlay(config)
                                .then(function (response) {
                                    const currentData = JSON.parse(state.sollicitationsMonPatrimoine || '[]');
                                    commit('SET_SOLLICITATIONS_MON_PATRIMOINE', JSON.stringify(currentData.concat(response.data)));
                                    decreaseFlag(etat, commit);
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                            entrees = entrees.slice(maxCount);
                        } while (entrees.length > 0);
                    } else {
                        console.log('[Erreur] URL trop longue');
                    }
                }

                if (nbProgs > 0) {
                    let progs = rootGetters['partenaires/programmes'];
                    maxCount = Math.floor((maxSizeURL - baseUrl.length) / 11);
                    if (maxCount >= 1) {
                        do {
                            increaseFlag(etat, commit);
                            url = baseUrl + "&programme=" + JSON.stringify(progs.slice(0, maxCount));
                            url += "&etat=" + JSON.stringify(etat.lettres);

                            let config = {
                                method: 'get',
                                url: url,
                                headers: {},
                                cancelToken: source.token
                            };

                            axiosOverlay(config)
                                .then(function (response) {
                                    const currentData = JSON.parse(state.sollicitationsMonPatrimoine || '[]');
                                    commit('SET_SOLLICITATIONS_MON_PATRIMOINE', JSON.stringify(currentData.concat(response.data)));
                                    decreaseFlag(etat, commit);
                                })
                                .catch(function (error) {
                                    console.log(error);
                                });

                            progs = progs.slice(maxCount);
                        } while (progs.length > 0);
                    } else {
                        console.log('[Erreur] URL trop longue');
                    }
                }
            });
    },

    async loadSollicitationsWithRelance({ dispatch }) {
        await dispatch('loadAllSollicitation', { debutgt: 1514768400, forceRefresh: false, relance: 1 });
    },

    async loadAllSollicitation({ commit, getters, rootGetters, dispatch }, { debutgt = 1577836800, forceRefresh = false, relance = 0 }) {
        if (forceRefresh || !getters.allSollicitations || getters.allSollicitations === '[]') {
            commit('SET_ALL_SOLLICITATIONS', JSON.stringify([]));

            let baseUrl = process.env.VUE_APP_API_URL + "/sollicitations?debut[gt]=" + debutgt;
            baseUrl += getFilterUrl(rootGetters);
            baseUrl += "&relance[gte]=" + relance;

            etats.forEach(etat => {
                let maxCount = Math.floor((maxSizeURL - baseUrl.length) / 11);
                let progs = rootGetters['entrees/getAllProgrammes'];
                if (maxCount >= 1) {
                    do {
                        increaseFlag(etat, commit);
                        let url = baseUrl + "&programme=" + JSON.stringify(progs.slice(0, maxCount));
                        url += "&etat=" + JSON.stringify(etat.lettres);

                        let config = {
                            method: 'get',
                            url: url,
                            headers: {},
                            cancelToken: source.token
                        };
                        
                        axiosOverlay(config)
                            .then(function (response) {
                                const currentData = JSON.parse(getters.allSollicitations || '[]');
                                commit('SET_ALL_SOLLICITATIONS', JSON.stringify([
                                    ...new Set([
                                        ...currentData,
                                        ...response.data
                                    ])
                                ]));
                                decreaseFlag(etat, commit);
                            })
                            .catch(function (error) {
                                console.log(error);
                            });

                        progs = progs.slice(maxCount);
                    } while (progs.length > 0);
                } else {
                    console.log('[Erreur] URL trop longue');
                }
            });
        }
        dispatch('switchAll');
    },

    async loadCreatedSollicitation({ commit, getters, rootGetters, dispatch }, { tiersReclamant, pecReclamant, debutgt = 1577836800, forceRefresh = false }) {
        if (forceRefresh || !getters.sollicitationsCreated) {
            etats.forEach(async etat => {
                let baseUrl = process.env.VUE_APP_API_URL + "/sollicitations?reclamant=" + tiersReclamant + "&type_reclamant=tiers";
                increaseFlag(etat, commit);

                if (debutgt != null)
                    baseUrl += "&debut[gt]=" + debutgt;

                baseUrl += "&etat=" + JSON.stringify(etat.lettres);

                let config = {
                    method: 'get',
                    url: baseUrl,
                    headers: {},
                    cancelToken: source.token
                };

                await axiosOverlay(config)
                    .then(function (response) {
                        const currentData = getters.sollicitationsCreated ? JSON.parse(getters.sollicitationsCreated) : [];
                        commit('SET_SOLLICITATIONS_CREATED', JSON.stringify([
                            ...new Set([
                                ...currentData,
                                ...response.data
                            ])
                        ]));
                        decreaseFlag(etat, commit);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });

                if (pecReclamant) {
                    baseUrl = process.env.VUE_APP_API_URL + "/sollicitations?pecsaisipar=" + pecReclamant;
                    baseUrl += getFilterUrl(rootGetters);

                    if (debutgt != null)
                        baseUrl += "&debut[gt]=" + debutgt;

                    let config = {
                        method: 'get',
                        url: baseUrl,
                        headers: {},
                        cancelToken: source.token
                    };
                    
                    const currentData = getters.sollicitationsCreated ? JSON.parse(getters.sollicitationsCreated) : [];
                    let solObjsIds = new Set(currentData.map(s => s.id));
                    increaseFlag(etat, commit);
                    
                    await axiosOverlay(config)
                        .then(function (response) {
                            commit('SET_SOLLICITATIONS_CREATED', JSON.stringify([
                                ...new Set([
                                    ...currentData,
                                    ...response.data.filter(s => !solObjsIds.has(s.id))
                                ])
                            ]));
                            decreaseFlag(etat, commit);
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            });
        }
        dispatch('switchCreated');
    },

    async loadAffectedSollicitation({ commit, getters, rootGetters, dispatch }, { pec, debutgt = 1577836800, forceRefresh = false }) {
        if (forceRefresh || !getters.sollicitationsAffected) {
            etats.forEach(async etat => {
                let baseUrl = process.env.VUE_APP_API_URL + "/sollicitations?responsable=" + pec;
                increaseFlag(etat, commit);
                baseUrl += getFilterUrl(rootGetters);
                baseUrl += "&etat=" + JSON.stringify(etat.lettres);

                if (debutgt != null)
                    baseUrl += "&debut[gt]=" + debutgt;

                let config = {
                    method: 'get',
                    url: baseUrl,
                    headers: {},
                    cancelToken: source.token
                };

                await axiosOverlay(config)
                    .then(function (response) {
                        const currentData = getters.sollicitationsAffected ? JSON.parse(getters.sollicitationsAffected) : [];
                        commit('SET_SOLLICITATIONS_AFFECTED', JSON.stringify([
                            ...new Set([
                                ...currentData,
                                ...response.data
                            ])
                        ]));
                        decreaseFlag(etat, commit);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            });
        }
        dispatch('switchAffected');
    },

    async reloadSingleSollicitation({ commit, state, dispatch }, sollicitationId) {
        let loadedSollicitation = await dispatch('loadSingleSollicitation', sollicitationId);
        
        if (state.sollicitationsAffected) {
            let solliciations = JSON.parse(state.sollicitationsAffected).filter(s => s.id != sollicitationId);
            solliciations.push(loadedSollicitation);
            commit('SET_SOLLICITATIONS_AFFECTED', JSON.stringify(solliciations));
        }
        
        if (state.sollicitationsCreated) {
            let solliciations = JSON.parse(state.sollicitationsCreated).filter(s => s.id != sollicitationId);
            solliciations.push(loadedSollicitation);
            commit('SET_SOLLICITATIONS_CREATED', JSON.stringify(solliciations));
        }
        
        if (state.sollicitationsMonPatrimoine) {
            let solliciations = JSON.parse(state.sollicitationsMonPatrimoine).filter(s => s.id != sollicitationId);
            solliciations.push(loadedSollicitation);
            commit('SET_SOLLICITATIONS_MON_PATRIMOINE', JSON.stringify(solliciations));
        }
        
        if (state.allSollicitations) {
            let solliciations = JSON.parse(state.allSollicitations).filter(s => s.id != sollicitationId);
            solliciations.push(loadedSollicitation);
            commit('SET_ALL_SOLLICITATIONS', JSON.stringify(solliciations));
        }
    },

    async loadSingleSollicitation(context, sollicitationId) {
        let baseUrl = process.env.VUE_APP_API_URL + "/sollicitations/" + sollicitationId;

        let config = {
            method: 'get',
            url: baseUrl,
            headers: {},
            cancelToken: source.token
        };

        return await axiosOverlay(config)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                console.log(error);
                return null;
            });
    },

    async closeSollicitation(context, { sollicitationID, codePec, closeMotifId = 'TRA', closeMsg = process.env.VUE_APP_CLOSE_MSG }) {
        let sollicitationIds = sollicitationID.split('-');
        let arrayData = {
            "numExe": sollicitationIds[0],
            "numRecla": sollicitationIds[1],
            "numLigne": sollicitationIds[2],
            "pec": codePec,
            "msg": closeMsg,
            "motif": closeMotifId
        };

        let data = JSON.stringify(arrayData);

        let config = {
            method: 'patch',
            url: process.env.VUE_APP_API_URL + "/cloturer_sollicitation",
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        return await axiosOverlay(config)
            .then(response => {
                return response.status === 200 || response.status === 201;
            })
            .catch(error => {
                console.log('error', error);
                return false;
            });
    },

    async createSollicitation({ commit }, sollicitationData) {
        const sollicitation = JSON.parse(sollicitationData);

        let arrayData = {
            "provenance": sollicitation.provenance,
            "reclamant": parseInt(sollicitation.reclamant),
            "typeReclamant": sollicitation.typeReclamant,
            "categorie": sollicitation.categorie,
            "type": sollicitation.type,
            "nature": sollicitation.nature,
            "motif": sollicitation.motif,
            "description": sollicitation.details,
            "entree": sollicitation.entree,
            "etage": sollicitation.etage
        };

        if (sollicitation.logement !== "") arrayData["logement"] = sollicitation.logement;
        if (sollicitation.pecsaisipar) arrayData["pecsaisipar"] = parseInt(sollicitation.pecsaisipar);

        if (sollicitation.fromSollicitation !== undefined) {
            arrayData["fromSollicitation"] = sollicitation.fromSollicitation;
        } else {
            arrayData["fromSollicitation"] = null;
        }

        let data = JSON.stringify(arrayData);

        let config = {
            method: 'post',
            url: process.env.VUE_APP_API_URL + "/sollicitations",
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        commit('SET_SELECTED_SOLLICITATION', null);
        
        return await axiosOverlay(config)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    commit('SET_SELECTED_SOLLICITATION', response.data['data']);
                    return response.data['data'];
                }
                return false;
            })
            .catch(error => {
                console.log('error', error);
                return false;
            });
    },

    setSelectedSollicitation({ commit }, sollicitationID) {
        commit('SET_SELECTED_SOLLICITATION', sollicitationID);
    },

    clearSollicitations({ commit }) {
        source.cancel();
        source = axios.CancelToken.source();
        commit('CLEAR_SOLLICITATIONS');
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
